import { render, staticRenderFns } from "./HubProfileDetails.vue?vue&type=template&id=3bad9354"
import script from "./HubProfileDetails.vue?vue&type=script&lang=js"
export * from "./HubProfileDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports